<template>
    <div class="thankyou-feature flex flex-col">
        <div v-if="icon" v-html="icon" class="text-center fill-current text-ma-blue-1 mb-2" />
        <h3 class="text-black text-lg mb-1">{{ feature.title }}</h3>
        <p class="text-ma-gray-3 mb-4">{{ feature.description }}</p>
        <a :href="feature.button.link" class="border-ma-blue-1 text-ma-blue-1 hover:bg-ma-blue-1 hover:text-white border-2 capitalize font-bold py-2 w-40 self-center">{{ feature.button.label }}</a>
    </div>
</template>

<script>
export default {
    props: {
        feature: {
            required: true,
            type: Object
        }
    },
    computed: {
        icon() {
            return require('!html-loader!../../../../assets/site/svg/'+ this.feature.icon +'.svg');
        }
    }
}
</script>